@if (activeSecurity.activeMembership$ | async) {
  @if (
    {
      rightSidebar: this.rightSidebarService.rightSidebar(),
      headerConfig: this.headerConfigState.headerConfig()
    };
    as state
  ) {
    <app-sales-popup></app-sales-popup>
    @if (state.headerConfig) {
      <app-shell (hrNavigationRequested)="onHrNavigationRequested($event)">
        <div app-header-menu>
          @if (state.headerConfig.activeProduct === 'EmployeeHub') {
            <app-employment-menu
              [activeEmployment]="activeSecurity.activeEmployment"
              [activeMembership]="activeSecurity.activeMembership"
              [memberships]="activeSecurity.memberships"
            ></app-employment-menu>
          } @else if (state.headerConfig.activeProduct === 'Bureau') {
            <app-bureau-menu
              [activeBureau]="activeSecurity.activeBureau"
              [bureauProfiles]="activeSecurity.activeUser.bureauProfiles"
            ></app-bureau-menu>
          } @else {
            <app-organisation-menu
              [activeMembership]="activeSecurity.activeMembership"
              [membershipsWithAdminAccess]="activeSecurity.membershipsWithAdminAccess"
            ></app-organisation-menu>
          }
        </div>
        @if (bannerService.banners$ | async; as banners) {
          @if (banners?.size) {
            <div id="banners">
              @for (banner of banners.entries(); track banner) {
                <app-banner [bannerName]="banner[0]" [contentType]="banner[1]"></app-banner>
              }
            </div>
          }
        }
        <!-- Content area with sidebar layout container -->
        <div class="content-with-sidebar-container">
          <div class="main-content-area">
            <div class="scrollable-content">
              <router-outlet></router-outlet>
            </div>
            <footer class="sticky-footer">
              @if (stickyFooterService.footerTemplate(); as footerTemplate) {
                <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
              }
            </footer>
          </div>
          <div id="right-side-bar-panel" [ngClass]="{ visible: state.rightSidebar.visible }">
            <app-right-sidebar></app-right-sidebar>
          </div>
        </div>
      </app-shell>
    }
    <app-slide-out-modal></app-slide-out-modal>
  }
}

<router-outlet name="modal"></router-outlet>
<router-outlet name="secondary-modal"></router-outlet>
<router-outlet name="tertiary-modal"></router-outlet>
<router-outlet name="message"></router-outlet>
<router-outlet name="selector"></router-outlet>
